import assetPath from '/app/packages/lebenslauf/articles/src/assets/die-kunst-der-initiativbewerbung-wie-du-dich-erfolgreich-selbst-ins-spiel-brings.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')